<template>
	<el-config-provider :locale="userBase.language=='zh'?zhCn:en">
		<div
			id="app"
			style="min-width: 1007px;"
		>
			<router-view />
		</div>
	</el-config-provider>
</template>

<script lang="ts" setup>
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import { onMounted } from 'vue';
import { useUserStore } from './store/user';

const userBase = useUserStore();

onMounted(() => {
	setRem();
	window.addEventListener('resize', () => setRem());

	userBase.init();
	userBase.getUserInfo();
	userBase.setIsChina();

	listenerScreenChang();
});

function setRem() {
	const size = (window.innerWidth / 1920) * 16;
	const element: any = document.documentElement;
	element.style = `font-size:${size < 14 ? 14 : size}px`;
}

function listenerScreenChang() {
	document.addEventListener('fullscreenchange', handleFullscreenChange);
	document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari/Chrome 旧版
	document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox 旧版
	document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge

	function handleFullscreenChange() {
		// 检查当前是否有元素处于全屏状态
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			userBase.isOpenScreenFull = true;
		} else {
			userBase.isOpenScreenFull = false;
		}
	}
}
</script>

<style lang="scss">
@import '@/common/css/global.scss';
@import '@/common/css/animate.min.css';
@import '@/common/css/customGlobal.css';

#app {
	font-size: 16px;
	font-family: 'Source Code Pro';
	font-weight: 400;
}
</style>
